import { defineStore } from 'pinia';

export const useSearchStore = defineStore('search', {
  state: () => ({
    isSearchSectionOpen: false,
    isSearchSuggestVisible: false
  }),
  actions: {
    toggleSearchSection() {
      this.isSearchSectionOpen = !this.isSearchSectionOpen;
    },
    openSearchSection() {
      this.isSearchSectionOpen = true;
    },
    closeSearchSection() {
      this.isSearchSectionOpen = false;
    },
    setSearchSuggestVisible(isVisible: boolean) {
      this.isSearchSuggestVisible = isVisible;
    }
  },
});
